export const SET_SHOW_PROMPT = "SET_SHOW_PROMPT";

export const ADD_APPLICANT_REQUEST = "applicant/ADD_APPLICANT_REQUEST";
export const ADD_APPLICANT_SUCCESS = "applicant/ADD_APPLICANT_SUCCESS";
export const ADD_APPLICANT_FAILURE = "applicant/ADD_APPLICANT_FAILURE";

export const UPLOAD_IMAGE = "applicant/UPLOAD_IMAGE";
export const UPLOAD_IMAGE_SUCCESS = "applicant/UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "applicant/UPLOAD_IMAGE_FAILURE";

export const UPLOAD_APPLICANT_DOCUMENTS = "applicant/UPLOAD_APPLICANT_DOCUMENTS";
export const UPLOAD_APPLICANT_DOCUMENTS_SUCCESS = "applicant/UPLOAD_APPLICANT_DOCUMENTS_SUCCESS";
export const UPLOAD_APPLICANT_DOCUMENTS_FAILURE = "applicant/UPLOAD_APPLICANT_DOCUMENTS_FAILURE";

export const DELETE_APPLICANT_DOCUMENTS = "applicant/DELETE_APPLICANT_DOCUMENTS";
export const DELETE_APPLICANT_DOCUMENTS_SUCCESS = "applicant/DELETE_APPLICANT_DOCUMENTS_SUCCESS";
export const DELETE_APPLICANT_DOCUMENTS_FAILURE = "applicant/DELETE_APPLICANT_DOCUMENTS_FAILURE";

export const FETCH_APPLICANTS_REQUEST = "applicant/FETCH_APPLICANTS_REQUEST";
export const FETCH_APPLICANTS_SUCCESS = "applicant/FETCH_APPLICANTS_SUCCESS";
export const FETCH_APPLICANTS_FAILURE = "applicant/FETCH_APPLICANTS_FAILURE";

export const CHECK_SCHEDULE_REQUEST = "applicant/CHECK_SCHEDULE_REQUEST";
export const CHECK_SCHEDULE_SUCCESS = "applicant/CHECK_SCHEDULE_SUCCESS";
export const CHECK_SCHEDULE_FAILURE = "applicant/CHECK_SCHEDULE_FAILURE";

export const FETCH_APPLICANT_REQUEST = "applicant/FETCH_APPLICANT_REQUEST";
export const FETCH_APPLICANT_SUCCESS = "applicant/FETCH_APPLICANT_SUCCESS";
export const FETCH_APPLICANT_FAILURE = "applicant/FETCH_APPLICANT_FAILURE";

export const UPDATE_APPLICANT_REQUEST = "applicant/UPDATE_APPLICANT_REQUEST";
export const UPDATE_APPLICANT_SUCCESS = "applicant/UPDATE_APPLICANT_SUCCESS";
export const UPDATE_APPLICANT_FAILURE = "applicant/UPDATE_APPLICANT_FAILURE";

export const RESET_IS_UPDATE_SUCCESSFUL =
  "applicant/RESET_IS_UPDATE_SUCCESSFUL";
export const SET_FAILED_DEFAULT_KEY = "applicant/SET_FAILED_DEFAULT_KEY";

export const SET_RESUME_FILENAME = "applicant/SET_RESUME_FILENAME";

export const RESET_APPLICANT_STATE = "applicant/RESET_APPLICANT_STATE";
export const RESET_ISOVERLAP = "applicant/RESET_ISOVERLAP";
export const RESET_APPLICANTS_STATE = "applicant/RESET_APPLICANTS_STATE";
export const CLEAR_APPLICANT_VALUES = "applicant/CLEAR_APPLICANT_VALUES";

export const SEARCH_APPLICANT_REQUEST = "applicant/SEARCH_APPLICANT_REQUEST";

export const FETCH_APPLICANTS_LIST_REQUEST = "applicant/FETCH_APPLICANTS_LIST_REQUEST";
export const FETCH_APPLICANTS_AFTER_A_YEAR_COUNT = "applicant/FETCH_APPLICANTS_AFTER_A_YEAR_COUNT";
export const FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_SUCCESS = "applicant/FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_SUCCESS";
export const FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_FAILURE = "applicant/FETCH_APPLICANTS_AFTER_A_YEAR_COUNT_FAILURE";

export const FETCH_TOTAL_APPLICANTS_REQUEST = "applicant/FETCH_TOTAL_APPLICANTS_REQUEST";
export const FETCH_TOTAL_APPLICANTS_SUCCESS = "applicant/FETCH_TOTAL_APPLICANTS_SUCCESS";
export const FETCH_TOTAL_APPLICANTS_FAILURE = "applicant/FETCH_TOTAL_APPLICANTS_FAILURE";
export const UPDATE_TOTAL_NEW_APPLICANTS = "applicant/UPDATE_TOTAL_NEW_APPLICANTS";
export const CLEAR_TOTAL_APPLICANTS = "applicant/CLEAR_TOTAL_APPLICANTS";
